import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

const StyledOption = styled.div`
  height: 25px;
  width: 100%;
  background-color: ${p => p.color};
  border: ${p => p.isSelected ? "2px solid var(--selected-color)" : "none"};
`

const Option = ({
  className,
  isSelected,
  color,
  src,
  onOptionSelect,
  thumbnail,
}) => {
  const onClick = React.useCallback(() => {
    onOptionSelect({ color, src, thumbnail })
  }, [])

  return (
    <StyledOption
      color={color}
      isSelected={isSelected}
      className={className}
      onClick={onClick}

    />
  )
}

Option.propTypes = {
  className: PropTypes.string,
  onOptionSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  color: PropTypes.string,
  src: PropTypes.string,
  thumbnail: PropTypes.string,
}
export default Option
